import _ from 'lodash'
import { AbstractListService } from '@/core/services/list.service'
import { AbstractSearchService } from '@/core/services/search.service'
import { AbstractEditService } from '@/core/services/edit.service'
import { ListFetchOptions } from '@/core/typing'
import { GET, POST } from '@/admin-shared-modules/utils/ajax'
import { defaultErrorHandler } from '@/admin-shared-modules/utils'
import { MessageService } from '@/admin-shared-modules/utils/message.service'
import moment from 'moment'

class List extends AbstractListService<Store> {
  summary = {}
  getFetchURL(): string {
    return 'credit/user/book/lend'
  }
  parseFetchedItems(data) {
    GET('credit/user/book/lend/statistic', {
      data: this.getSearchParams()
    }).then(({ data }) => {
      this.summary = data
    })
    return super.parseFetchedItems(data)
  }
  getSearchParams() {
    const data = this.context.search.getSearchParams()
    return {
      credit_user_id: this.context.userId,
      ...data
    }
  }
}

class Search extends AbstractSearchService<Store> {
  getDefaultFormData() {
    return { tab: 0 }
  }
  getSearchParams() {
    return this.omitEmptyString({
      ...this.data,
      begin_date: _.size(this.data.dateRange)
        ? moment(this.data.dateRange[0]).format('YYYY-MM-DD')
        : null,
      end_date: _.size(this.data.dateRange)
        ? moment(this.data.dateRange[1]).format('YYYY-MM-DD')
        : null,
      lend_type: [null, 0, 1][this.data.tab]
    })
  }
  onSubmit(): void {
    this.context.list.fetch({ reset: true })
  }
}

class Store {
  list: List
  search: Search
  userId: string
  visible = false

  constructor() {
    this.list = new List(this)
    this.search = new Search(this)
  }

  open({ userId, begin_date, end_date }) {
    this.userId = userId
    this.visible = true
    this.list.fetch({ reset: true })
  }
}

export const store = new Store()
